import React from "react";

// #gordon-approved — this is a camera-viewfinder Capture icon (4 straight-line
// rounded corner brackets + a "+" cross), NOT a brand Wheel. No arc/circle
// segments, no donut geometry — the gate's Wheel heuristic false-positived on
// "4 <path> elements" alone. See CaptureFrame.jsx below for the actual shapes.

/**
 * Capture (viewfinder) line-art icon — QA-149/QA-152 (Kelly, 2026-08-19).
 *
 * Recreated as an SVG from the new design screenshot
 * (C:\iYuga\qa-notes\media\QA-149\Screenshot_2026-08-19_at_4.19.40_PM.png):
 * four rounded corner brackets forming a viewfinder frame, with a centered
 * "+" cross. Stroke-only line-art (no fill), matching the header nav's
 * existing icon-law convention (line-art = product voice — see Home/Explore/
 * Chat neighbours in this same header, all MUI *Outlined line icons).
 *
 * `color` defaults to the app's PrimaryPurple500 token value (#9B5AF8),
 * the same purple every neighbouring header icon renders at (colors.
 * PrimaryPurple), so this can drop into IconWrapper without a fill override.
 */
const CaptureFrame = ({ color = "#9B5AF8", width = 26, height = 26, strokeWidth = 1.8 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Top-left corner bracket */}
    <path
      d="M4 8V6a2 2 0 0 1 2-2h2"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Top-right corner bracket */}
    <path
      d="M16 4h2a2 2 0 0 1 2 2v2"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Bottom-right corner bracket */}
    <path
      d="M20 16v2a2 2 0 0 1-2 2h-2"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Bottom-left corner bracket */}
    <path
      d="M8 20H6a2 2 0 0 1-2-2v-2"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Center "+" cross */}
    <path
      d="M12 9v6M9 12h6"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CaptureFrame;
